import { render, staticRenderFns } from "./EntityProduct.vue?vue&type=template&id=535f1476&scoped=true"
import script from "./EntityProduct.vue?vue&type=script&lang=js"
export * from "./EntityProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535f1476",
  null
  
)

export default component.exports